import { getWindow } from 'utilities/window.js';

const getPostHogLib = async () => {
  const phConfig = getWindow()?.phConfig;
  if (phConfig?.token) {
    const lib = await import(
      /* webpackChunkName: "posthog" */
      'posthog-js'
    );
    const posthog = lib.posthog;
    return posthog;
  }
};

export const phConfigInit = async () => {
  const postHogLib = await getPostHogLib();
  const phConfig = getWindow()?.phConfig;
  const phToken = getWindow()?.phConfig?.token;
  if (phConfig && phToken && postHogLib) {
    postHogLib.init(phToken, {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      ...phConfig,
    });
  }
};

// const phCapture = async (name: string, captureProps: Record<string, Primitive>) => {
//   const postHogLib = await getPostHogLib();
//   if (postHogLib) {
//     postHogLib.capture(name, captureProps);
//   }
// };
